export const TRANSACTION_STATUS = {
  SPEND: 'SPEND',
  DEPOSIT: 'DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  REFUND: 'REFUND',
}

export const TRANSACTION_STATUS_TEXT_COLOR = {
  [TRANSACTION_STATUS.SPEND]: 'red',
  [TRANSACTION_STATUS.DEPOSIT]: 'green',
  [TRANSACTION_STATUS.WITHDRAW]: 'red',
  [TRANSACTION_STATUS.REFUND]: 'purple',
}
